export enum RewardCultureResourceType {
  AUTO_BANKED_POINTS = 'AutoBankedPoints',
  BANKED_POINTS = 'BankedPoints',
  EXPIRED_POINTS = 'ExpiredPoints',
  CLAIMED_REWARD = 'ClaimedReward',
  SUBMIT_POINTS = 'SubmitPoints',
  REMOVED_POINTS = 'RemovePoints',
}
